import CheckInCustomerDetailsContainer from "./CheckInCustomerDetailsContainer";
import CheckInCustomerDetailsStore from "./CheckInCustomerDetailsStore";
export default CheckInCustomerDetailsStore(CheckInCustomerDetailsContainer);